'use strict';

var processInclude = require('base/util');

(async () => {
    try {
        processInclude(require('app_custom_mufe/mufe'));
        processInclude(require('./components/utilities'));
        processInclude(require('./contact.js'));
    } catch (err) {
        console.log(err);
    }
})();